var $ = window.jQuery;

export default function() {

  $('.accommodation_detailed-item').find('button.toggle').on('click', function() {
    $(this).closest('.accommodation_detailed-item').find('svg.chevron').first().toggleClass('-rotate-180 transform');
    $(this).closest('.accommodation_detailed-item').find('dd').first().toggleClass('hidden');

    //sort out rendering of sliders
    window.dispatchEvent(new Event('resize'));
  })
}
